export type LegacyScheduleState = {
  id: string
  code: string
  name: string
  color: string
  description: string
}

export const legacyScheduleStateOffices = Array.from({ length: 26 }, (_, index) => ({
  id: String(index + 1),
  name: `Mock 지점 ${String(index + 1).padStart(2, '0')}`,
}))

const descriptions = [
  '기본 예) 촬영이 예약된 기본 상태',
  '기본 예) 촬영이 정상적으로 완료되었을 때',
  '기본 예) 촬영 전, 다른 촬영일 예약 없이 미루었을 때',
  '기본 예) 촬영 당일, 다른 촬영일 예약 없이 취소했을 때',
  '기본 예) 촬영 전, 다른 촬영일을 예약하고 미루었을 때',
  '기본 예) 촬영 당일, 연락 없이 오지 않았을 때',
  '기본 예) 촬영 2주 전, 예약 일시의 방문을 확정했을 때',
  '기본 예) 촬영 전, 예약 일시의 방문을 확정했을 때',
]

const colors = ['#68c9ff', '#8ddca4', '#ffd36f', '#ff9f9f', '#c9b5ff', '#b7b7b7', '#58d8d8', '#ef9fc4']

export const legacyScheduleStates: LegacyScheduleState[] = descriptions.map((description, index) => ({
  id: `mock-state-${index + 1}`,
  code: `S${String(index + 1).padStart(2, '0')}`,
  name: `Mock 스케줄 상태 ${String(index + 1).padStart(2, '0')}`,
  color: colors[index],
  description,
}))

export const legacyScheduleStateSwatches = [
  '#ff0000', '#ff6347', '#ff8c00', '#ffd700', '#ffff00', '#7fff00',
  '#00ff7f', '#40e0d0', '#00ffff', '#00bfff', '#0000ff', '#800080',
  '#ff00ff', '#ff1493', '#008080', '#000080', '#808080', '#c0c0c0',
]
